/**
 * Execution block: opens a URL in a new browser tab.
 * Config: none (URL comes from data input)
 * Data input: url (string)
 * Flow: in → out
 */

import { FlowGraphExecutionBlockWithOutSignal } from "@babylonjs/core/FlowGraph/flowGraphExecutionBlockWithOutSignal";
import type { FlowGraphContext } from "@babylonjs/core/FlowGraph/flowGraphContext";
import type { FlowGraphSignalConnection } from "@babylonjs/core/FlowGraph/flowGraphSignalConnection";
import { RichTypeString } from "@babylonjs/core/FlowGraph/flowGraphRichTypes";
import type { IFlowGraphBlockConfiguration } from "@babylonjs/core/FlowGraph/flowGraphBlock";

export class TraceNavigateBlock extends FlowGraphExecutionBlockWithOutSignal {
    constructor(config?: IFlowGraphBlockConfiguration) {
        super(config);
        this.registerDataInput("url", RichTypeString, '');
    }

    public override _execute(context: FlowGraphContext, _callingSignal: FlowGraphSignalConnection): void {
        const url = this.getDataInput("url")!.getValue(context) as string;
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
        this.out._activateSignal(context);
    }

    public override getClassName(): string {
        return "TraceNavigateBlock";
    }
}
